import { Controller } from 'react-hook-form';
import DateSelector from '@/components/dateSelector';

function DateSelectorController({
  id,
  name,
  label,
  skipLabel,
  appointmentOptions,
  control,
  placeholder,
  defaultValue,
}) {
  return (
    <Controller
      name={id}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange } }) => (
        <DateSelector
          placeholder={placeholder}
          id={id}
          name={name}
          appointmentOptions={appointmentOptions}
          onChange={(data) => {
            onChange(data);
          }}
          label={label}
          defaultValue={defaultValue}
          skipLabel={skipLabel}
        />
      )}
    />
  );
}
export default DateSelectorController;
